/**
 * Идентичность игрока: login + password в localStorage.
 * Сервер хранит playerId (UUID) и логирует по login+password (sha256).
 */

const KEY_LOGIN = "banzai.login";
const KEY_PASSWORD = "banzai.password";   // ⚠ хранится в plain в localStorage —
                                          //    auto-login UX-удобство; пароль игровой,
                                          //    не банковский, см. issue в README
const KEY_AI_DIFFICULTY = "banzai.ai_difficulty";
const KEY_PLAYER_SLUG = "banzai.player_slug";

export function getStoredCredentials(): { login: string; password: string } | null {
  const login = localStorage.getItem(KEY_LOGIN);
  const password = localStorage.getItem(KEY_PASSWORD);
  if (!login || !password) return null;
  return { login, password };
}

export function setStoredCredentials(login: string, password: string): void {
  localStorage.setItem(KEY_LOGIN, login);
  localStorage.setItem(KEY_PASSWORD, password);
}

export function clearStoredCredentials(): void {
  localStorage.removeItem(KEY_LOGIN);
  localStorage.removeItem(KEY_PASSWORD);
}

export function getLoginRegex(): RegExp {
  return /^[a-zA-Z0-9_\-Ѐ-ӿ]{2,16}$/;
}

export function validateLogin(login: string): string | null {
  if (!login.trim()) return "Логин не может быть пустым";
  if (!getLoginRegex().test(login)) return "2–16 символов: буквы (рус/eng), цифры, _ -";
  return null;
}

// ── AI difficulty ────────────────────────────────────────────────────────────
// Прогрессия идёт автоматом: каждая новая тренировка стартует с «новичка»,
// победы поднимают уровень, поражения опускают. Поэтому хранение не должно
// «помнить» уровень между визитами — sessionStorage очищается при закрытии
// вкладки, и в следующий заход игрок снова начинает с novice.
export type AIDifficulty = "novice" | "veteran" | "master";

export function getStoredAIDifficulty(): AIDifficulty {
  try {
    const v = sessionStorage.getItem(KEY_AI_DIFFICULTY);
    if (v === "novice" || v === "veteran" || v === "master") return v;
  } catch (_e) { /* sessionStorage может быть запрещён — fallback на default */ }
  return "novice";
}

export function setStoredAIDifficulty(level: AIDifficulty): void {
  try { sessionStorage.setItem(KEY_AI_DIFFICULTY, level); } catch (_e) {}
}

export function resetAIDifficulty(): void {
  try { sessionStorage.removeItem(KEY_AI_DIFFICULTY); } catch (_e) {}
}

// ── Выбранный архетип игрока (хранится постоянно в localStorage) ─────────────
const PLAYER_SLUGS = ["boxer_leo", "boxer_mike", "boxer_don", "boxer_raph"] as const;
export type PlayerSlug = typeof PLAYER_SLUGS[number];

export function getStoredPlayerSlug(): PlayerSlug {
  const v = localStorage.getItem(KEY_PLAYER_SLUG);
  if (v && (PLAYER_SLUGS as readonly string[]).includes(v)) return v as PlayerSlug;
  return "boxer_leo";
}

export function setStoredPlayerSlug(slug: PlayerSlug): void {
  localStorage.setItem(KEY_PLAYER_SLUG, slug);
}
